import loadable from "@loadable/component";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./util/PrivateRoute";
import "./App.scss";

const FullScreenLayout = loadable(() => import("./layouts/FullScreenLayout"));
const ResponsiveLayout = loadable(() => import("./layouts/ResponsiveLayout"));
const DashboardLayout = loadable(() => import("./layouts/DashboardLayout"));
const Login = loadable(() => import("./pages/Login"));
const CareUnitSelection = loadable(() => import("./pages/CareUnitSelection"));
const Dashboard = loadable(() => import("./pages/Dashboard"));
const Accounts = loadable(() => import("./pages/Accounts"));
const BoxDispatch = loadable(() => import("./pages/BoxDispatch"));
const BoxPairing = loadable(() => import("./pages/BoxPairing"));
const BoxWifi = loadable(() => import("./pages/BoxWifi"));
const PatientDetail = loadable(() => import("./pages/PatientDetail"));
const About = loadable(() => import("./pages/About"));
const ConnCheck = loadable(() => import("./pages/ConnectionCheck"));
const NotFound = loadable(() => import("./pages/NotFound"));
const AlertSidebar = loadable(() =>
  import("./components/Sidebars/AlertSidebar")
);
const TopBar = loadable(() => import("./components/TopBar/TopBarMainMenu"));

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={<FullScreenLayout children={<Login />} />}
        />
        <Route
          path="/conncheck"
          element={<FullScreenLayout children={<ConnCheck />} />}
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <FullScreenLayout children={<CareUnitSelection />} />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                dashboard={<Dashboard />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/accounts"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                main={<Accounts />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/boxdispatch"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                main={<BoxDispatch />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/boxpairing"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                main={<BoxPairing />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/boxwifi"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                main={<BoxWifi />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/patient/:patientSn"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                main={<PatientDetail />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/patientDetail"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                sidebar={<AlertSidebar />}
                main={<PatientDetail />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/about"
          element={
            <PrivateRoute>
              <ResponsiveLayout
                topbar={<TopBar />}
                sidebar={<AlertSidebar />}
                main={<About />}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="*"
          element={<FullScreenLayout children={<NotFound />} />}
        />
      </Routes>
    </Router>
  );
};

export default App;